export enum ClientRole {
  ROLE_DEFAULT = 'ROLE_DEFAULT',
  ROLE_OWNER = 'ROLE_OWNER',
  ROLE_VIESTURS= 'ROLE_VIESTURS',
}
